import React, { Component } from "react";
import Fade from "react-reveal";

class Portfolio extends Component {
  render() {
    if (!this.props.data) return null;
    const projects = this.props.data.projects.map((projects, index) => {
      let projectImage =
        process.env.PUBLIC_URL + "/images/portfolio/" + projects.image;
      const showPdf = index < 5 && projects.pdf;

      return (
        <div
          key={projects.title}
          data-index={index}
          className="portfolio-item"
        >
          <a
            className="item-wrap portfolio-card"
            href={projects.url}
            target="_blank"
            rel="noopener noreferrer"
          >
            <div className="portfolio-image">
              <img alt={projects.title} src={projectImage} />
            </div>
            <div className="portfolio-content">
              <h3 className="portfolio-title">{projects.title}</h3>
              <p className="portfolio-category">{projects.category}</p>
              {projects.tech ? (
                <div className="portfolio-tags">
                  {projects.tech.map((tag) => (
                    <span key={tag} className="portfolio-tag">
                      {tag}
                    </span>
                  ))}
                </div>
              ) : null}
              {showPdf ? (
                <div className="portfolio-actions">
                  <a
                    className="portfolio-pdf-btn"
                    href={projects.pdf}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    View PDF
                  </a>
                </div>
              ) : null}
            </div>
          </a>
        </div>
      );
    });

    return (
      <section id="portfolio">
        <Fade left duration={1000} distance="40px">
          <div className="row">
            <div className="twelve columns collapsed">
              <h1>Check Out Some of My Works.</h1>

              <div id="portfolio-wrapper" className="portfolio-grid">
                {projects}
              </div>
            </div>
          </div>
        </Fade>
      </section>
    );
  }
}

export default Portfolio;
